import React from "react"
import { FiGithub, FiChevronUp } from "react-icons/fi"
import { GrLinkedin } from "react-icons/gr"
import { FaStackOverflow } from "react-icons/fa"

import styles from "./footer.module.scss"

function Footer() {
  const scrollToTop = () => {
    const container = document.querySelector("#containerElement")
    if (container) {
      container.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    }
  }

  const currentYear = new Date().getFullYear()

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <button className={styles.scrollTop} onClick={scrollToTop} aria-label="Scroll to top">
          <FiChevronUp />
        </button>

        <div className={styles.socials}>
          <a
            href="https://www.linkedin.com/in/abhay-sharma-3955a73b/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
          >
            <GrLinkedin />
          </a>
          <a
            href="https://stackoverflow.com/users/9463179/abhay-sharma"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
          >
            <FaStackOverflow />
          </a>
          <a
            href="https://github.com/sharmaabhay18"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
          >
            <FiGithub />
          </a>
        </div>

        <div className={styles.copyright}>
          <p>© {currentYear} Abhay Sharma. All rights reserved.</p>
          <p className={styles.small}>Built with passion using Gatsby.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
